<template>
  <div>
    <v-row class="mb-1">
      <v-col cols="6">
        <h2>Data Lainnya</h2>
      </v-col>
      <v-col cols="6" class="text-right">
        <doktambahanModalEdit />
      </v-col>
    </v-row>

    <div>
      <v-alert v-model="alertBerhasil" type="success" dense dismissible>
        {{ alertMassage }}
      </v-alert>
      <v-alert v-model="alertGagal" type="error" dense dismissible>
        {{ alertMassage }}
      </v-alert>
    </div>

    <v-card :loading="ldata">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Dokumen Tambahan</th>
              <th class="text-left">Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Punya Rumah Sendiri?</td>
              <td>{{ rumah.nama }}</td>
            </tr>
            <tr>
              <td>BAPERTARUM?</td>
              <td>{{ bapertarum.nama }}</td>
            </tr>
            <tr>
              <td>Hobby</td>
              <td>{{ hobby }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import Auth from "@/helper/auth.js";

import doktambahanModalEdit from "@/components/asn/profil/doktambahan/ModalEdit";

import refreshView from "@/store/asn/doktambahan/viewDoktambahan";

export default {
  name: "doktambahan",

  components: {
    doktambahanModalEdit,
  },

  computed: {
    refresh: {
      get() {
        return refreshView.state.Refresh;
      },
    },

    alertMassage: {
      get() {
        return refreshView.state.alertMassage;
      },
    },

    success: {
      get() {
        return refreshView.state.success;
      },

      set(value) {
        refreshView.commit("alert", value);
      },
    },

    alertBerhasil: {
      get() {
        return refreshView.state.alertBerhasil;
      },

      set(value) {
        refreshView.commit("berhasilAlert", value);
      },
    },

    alertGagal: {
      get() {
        return refreshView.state.alertGagal;
      },

      set(value) {
        refreshView.commit("gagalAlert", value);
      },
    },
  },

  watch: {
    refresh() {
      this.getData();
      setTimeout(() => {
        this.alertGagal = false;
        this.alertBerhasil = false;
      }, 5000);
    },
  },

  async mounted() {
    this.get_nip = this.$route.params.id;
    this.getData();
  },

  data: () => ({
    token: Cookie.get("token"),

    ldata: true,

    get_nip: "",
    rumah: "",
    bapertarum: "",
    hobby: "",
  }),

  methods: {
    getData() {
      this.ldata = true;
      const url = process.env.VUE_APP_ASN + "tambahan/nip/" + this.get_nip;

      this.http
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          this.ldata = false
          refreshView.commit("refreshData", false);
          this.rumah = response.data.mapData.DataTambahan.rumah;
          this.bapertarum = response.data.mapData.DataTambahan.bapertarum;
          this.hobby = response.data.mapData.DataTambahan.hobby;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            Auth.logout(this.token);
          } else if (error.response) {
            console.log(error.response.status);
          } else {
            console.log("Error", error.message);
          }
        });
    },
  },
};
</script>
